import * as types from '../../index';


export const sectorListAction = (data) => {
    return {
    type: types.SECTOR_LIST_SUPERADMIN,
    data
    }
};

export const sectorAllListAction = (data) => {
    return {
    type: types.SECTOR_ALL_SUPERADMIN_LIST,
    data
    }
};

export const sectorAddAction = (data) => {
    return {
    type: types.SECTOR_ADD_SUPERADMIN,
    data
    }
};

export const sectorEditAction = (data) => {
    return {
    type: types.SECTOR_EDIT_SUPERADMIN,
    data
    }
};

export const sectorUpdateAction = (data) => {
    return {
    type: types.SECTOR_UPDATE_SUPERADMIN,
    data
    }
};

export const sectorDeleteAction = (data) => {
    return {
    type: types.SECTOR_DELETE_SUPERADMIN,
    data
    }
};